import React from 'react';
import { Trans } from 'react-i18next';
import { IconCross, IconDocument, IconUpload } from '@components/icons';
import Papa from 'papaparse';

import { FileLoader } from '../components/file-loader';
import { MIME_TYPE_CSV } from '../components/file-loader.type';

import { InputCsvParserProps } from './input-csv-parser.type';

export const InputCsvParser = ({ delimiter, setFileName, setRows, fileName }: InputCsvParserProps) => {
  const transformData = (data: unknown[][]): unknown[][] => {
    const headers = data[0];
    const newRows = data.slice(1);

    const columns = headers.map((header, index) => {
      return [header, ...newRows.map((row) => row[index] ?? '')];
    });

    return columns;
  };
  const parseCSV = (text: string | ArrayBuffer | null) => {
    // eslint-disable-next-line
    // @ts-ignore
    // eslint-disable-next-line
    Papa.parse(text, {
      delimiter,
      header: false,
      skipEmptyLines: false,
      complete: (result: { data: unknown[] }) => {
        const transformedData = transformData(result.data as unknown[][]);
        setRows(transformedData as Array<string[]>);
      },
    });
  };

  const handleFileUpload = (file: File) => {
    if (file) {
      setFileName(file.name);
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        parseCSV(text);
      };
      reader.readAsText(file);
    }
  };

  const handleClear = () => {
    setRows([]);
    setFileName('');
  };

  return (
    <div>
      {!fileName && (
        <FileLoader handleFileUpload={handleFileUpload} type={MIME_TYPE_CSV}>
          <IconUpload className='text-gray-700 w-6 h-6 mb-2' />
          <span className='text-primary text-center'>
            <Trans i18nKey='offers:importCsvDescription'>
              <br />
              <span className='underline font-bold' />
            </Trans>
          </span>
          <span className='text-gray-500 text-sm'>CSV</span>
        </FileLoader>
      )}
      {fileName && (
        <div className='flex items-center py-3 px-4 gap-4 bg-surface-secondary rounded-[4px]'>
          <IconDocument className='text-primary w-8 h-8 ' />
          <p className='text-primary font-bold leading-5 grow'>{fileName}</p>
          <button type='button' onClick={handleClear}>
            <IconCross className='shrink-0 w-3 h-3 text-primary' aria-label='clear file' />
          </button>
        </div>
      )}
    </div>
  );
};
